var map = {
	"./404.png": 816,
	"./add.png": 2177,
	"./android.png": 8997,
	"./back.png": 8887,
	"./bg-send.png": 2956,
	"./checked.png": 6903,
	"./close_black.png": 6420,
	"./coin1.png": 2644,
	"./cpu.png": 4094,
	"./facebook-active.png": 963,
	"./facebook.png": 3902,
	"./gmail-active.png": 2063,
	"./gmail.png": 4194,
	"./hamburger.png": 1661,
	"./home.png": 5091,
	"./instagram-active.png": 5421,
	"./instagram.png": 9452,
	"./internet.png": 3329,
	"./ios.png": 5835,
	"./iot.png": 5892,
	"./line-street.png": 6898,
	"./location.png": 9895,
	"./mobile-icon.png": 752,
	"./mobile-img.png": 4302,
	"./mobile1-icon.png": 2141,
	"./outsource-icon.png": 9673,
	"./outsource1-icon.png": 5902,
	"./remove-file.png": 731,
	"./software-icon.png": 7427,
	"./software-img.png": 2479,
	"./software1-icon.png": 5404,
	"./submit-success.png": 8772,
	"./topduo.png": 2273,
	"./tv.png": 6064,
	"./wearalabel.png": 8478,
	"./web-icon.png": 5014,
	"./web-img.png": 5136,
	"./web1-icon.png": 1983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6400;